import { useContext, useMemo } from 'react';

import NavigationConfirmationPromptContext from './context';

const useNavigationConfirmationPrompt = () => {
  const { handler, resetHandler } = useContext(NavigationConfirmationPromptContext);

  return useMemo(
    () => ({
      cancel: () => {
        handler?.cancel();
        resetHandler();
      },
      discard: () => {
        handler?.discard();
        resetHandler();
      },
      save: async () => {
        await handler?.save();
        resetHandler();
      },
      isDisplayed: Boolean(handler),
    }),
    [handler, resetHandler],
  );
};

export default useNavigationConfirmationPrompt;
